// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoadingsIndicator_loader__2bWxq","spin":"LoadingsIndicator_spin__nwWfi"};